import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  Paper, BottomNavigation, BottomNavigationAction, Menu, MenuItem,
} from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { sessionActions } from '../../store';
import useOperationalPermissions from '../util/operationalPermissions';
import { useRestriction } from '../util/permissions';

const BottomMenu = ({ onNotifications }) => {
  const navigate = useNavigate();
  const { read, operate, administer, haulier } = useOperationalPermissions();
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const disableReports = useRestriction('disableReports');
  const [anchorEl, setAnchorEl] = useState(null);
  const go = (path) => { setAnchorEl(null); navigate(path); };
  const selected = pathname === '/' ? '/' : pathname.startsWith('/gate-operations') || pathname.startsWith('/trips') ? '/gate-operations' : pathname === '/vehicles' ? '/vehicles' : 'more';
  const logout = async () => {
    const response = await fetch('/api/session', { method: 'DELETE' });
    if (response.ok) { dispatch(sessionActions.updateUser(null)); navigate('/login'); }
  };
  return (
    <Paper square elevation={3} component="nav" aria-label="Primary navigation">
      <BottomNavigation showLabels value={selected} onChange={(event, value) => (value === 'more' ? setAnchorEl(event.currentTarget) : go(value))}>
        <BottomNavigationAction label="In-plant operations" icon={<DashboardIcon />} value="/" />
        {operate && <BottomNavigationAction label="Gate operations" icon={<MeetingRoomIcon />} value="/gate-operations" />}
        {(operate || haulier) && <BottomNavigationAction label="Vehicles" icon={<LocalShippingIcon />} value="/vehicles" />}
        <BottomNavigationAction label="More" icon={<MoreHorizIcon />} value="more" />
      </BottomNavigation>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
        <MenuItem onClick={() => { setAnchorEl(null); onNotifications(); }}>Notifications and alerts</MenuItem>
        {read && <MenuItem onClick={() => go('/live')}>Live tracking</MenuItem>}
        {read && <MenuItem onClick={() => go('/trips')}>Trips</MenuItem>}
        {read && <MenuItem onClick={() => go('/fleet-insights')}>Fleet insights</MenuItem>}
        {!haulier && <MenuItem onClick={() => go('/outbound-operations')}>Outbound operations</MenuItem>}
        {!haulier && <MenuItem onClick={() => go('/plant-tracking')}>Plant tracking</MenuItem>}
        {!haulier && <MenuItem onClick={() => go('/outbound-tracking')}>Outbound tracking</MenuItem>}
        {operate && <MenuItem onClick={() => go('/yard-intake')}>Parking intake</MenuItem>}
        {operate && <MenuItem onClick={() => go('/shift-desk')}>Shift desk</MenuItem>}
        {!haulier && <MenuItem onClick={() => go('/exceptions')}>Exceptions</MenuItem>}
        {!disableReports && !haulier && <MenuItem onClick={() => go('/reports')}>Reports</MenuItem>}
        {!disableReports && !haulier && <MenuItem onClick={() => go('/analytics')}>Analytics</MenuItem>}
        {administer && <MenuItem onClick={() => go('/configuration')}>Configuration</MenuItem>}
        <MenuItem onClick={() => go('/account')}>My account</MenuItem>
        <MenuItem onClick={logout}>Sign out</MenuItem>
      </Menu>
    </Paper>
  );
};
export default BottomMenu;
